import { LocalStorageService } from '@df/browser/storage/local-storage.service';
import { IProductDataV2, Product } from '@df/catalog/product/product';
import { ProductResource } from '@df/catalog/product/product.resource';
import { NSamples } from '@df/samples/samples.namespace';
import { IAddToBasketData } from '@df/session/api/basket/basket';
export class Sample {
    private _data?: NSamples.ISampleData;
    constructor(
        public productId: number,
        private productResource: ProductResource,
        private localStorageService: LocalStorageService
    ) {
        this.data = this.localStorageService.get(this.storageName) || {};
    }
    /**
     * Data setter - syncs data object with local storage
     * @param  {ISampleData} data
     */
    set data(data: NSamples.ISampleData) {
        this.localStorageService.set(this.storageName, data || {});
        this._data = data || {};
    }
    /**
     * Data getter
     * @return {ISampleData} [description]
     */
    get data(): NSamples.ISampleData | undefined {
        return this._data;
    }
    private get storageName(): string {
        return `customerSample.${this.productId}`;
    }
    /**
     * Sample product
     * @return {Product}
     */
    get product(): Product<IProductDataV2> {
        return this.productResource.getCreate(this.productId) as Product<IProductDataV2>;
    }
    /**
     * Clear local storage on destroy
     */
    onDestroy() {
        this.localStorageService.set(this.storageName, null);
    }
    /**
     * Retrieves add to basket request
     * @return {number} [description]
     */
    toBasketRequest(): IAddToBasketData | undefined {
        const id = this.productId;
        if (id) {
            return { id: id, qty: 1 };
        }
        return undefined;
    }
}
